import {
  DueWidget, TasksWidget, AttendanceWidget, BillingWidget, RevenueWidget, UnbilledWidget,
  ActionsWidget, RenewalsWidget, LeadsWidget, ClientsWidget, OfficeWidget, ComplianceWidget,
} from './widgets/widgets';

// widget key → component. Titles, sizes, scope labels and who may use each
// widget come from the server (ca-backend/config/dashboardWidgets.js, same keys),
// so a widget exists on the dashboard only when it is in BOTH places.
export const WIDGET_COMPONENTS = {
  due: DueWidget,
  tasks: TasksWidget,
  attend: AttendanceWidget,
  bvc: BillingWidget,
  fin: RevenueWidget,
  unbilled: UnbilledWidget,
  actions: ActionsWidget,
  renewals: RenewalsWidget,
  leads: LeadsWidget,
  clients: ClientsWidget,
  office: OfficeWidget,
  cal: ComplianceWidget,
};
